<template>
    <div>
        <div
            class="form-check"
            v-for="(menuItem, index) in menuItems"
            :key="index"
        >
            <input
                class="form-check-input"
                type="checkbox"
                :id="`${menuName}_checkbox_${index}`"
                :disabled="menuItems.length == 1 && !menuItem.visible"
                v-model="menuItem.visible"
                :true-value="true"
                :false-value="false"
                @change="setNewHeaders(index, $event.target.checked)"
            >
            <label class="form-check-label" :for="`${menuName}_checkbox_${index}`">
                {{ menuItem.label }}
            </label>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            headerContextMenuName: {type: String, required: true}, // Menu name for localStorage identify
            menuName: {type: String, required: true},              // Menu name for identification of menu if them will be 2,3,4 or more
            menuItems: {type: Array, required: true},              // Menu items array for displaying
        },
        methods: {
            setNewHeaders(index, value) {
                this.menuItems[index].visible = value;
                this.$store.dispatch("userLocalSettings/SET_TABLE_HEADER_SETTINGS_SMART", {
                    tableName: this.headerContextMenuName,
                    settings: this.headersFilterPrepare(this.menuItems)
                })
            },
            headersFilterPrepare(headers) {
                let result = {}

                headers.forEach((headerItem) => {
                    result[headerItem.key] = {
                        'visible': headerItem.visible
                    }
                })

                return result
            }
        }
    }
</script>
